'use strict';

var formonlineApp = angular.module('formonlineApp');

formonlineApp.service('SidebarService', function ($filter, $log, $localStorage) {

	this.LOCAL_STORAGE_KEY = 'LS_SIDEBAR_TREE';

	this.nodeSelected = {};
	this.nodeSelected.menus = [];
	this.tree = [];
	this.idSsMenuSelected;
	this.ssMenuSelected;
	this.menuSelected;


	/* Exemple :
	this.tree = [{
		type: 'D',
		menus: [{
				label: 'Recherche',
				url: 'dossier',
				ssmenus : []
			}, {
				label: 'Dossiers ouverts',
				url: '',
				ssmenus : [
					{
						label: '1234',
						url: 'dossier.detail(1234)',
						id: 1234,
						ssmenus: []
					}]
			}]
		}];
	*/

	this.searchSsMenu = function (id) {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
				if (this.nodeSelected.menus[i].ssmenus[j].id.toString() === id.toString()) {
					return this.nodeSelected.menus[i].ssmenus[j];
				}
			}
		}
		return null;
	};
	this.searchMenu = function (id) {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
				if (this.nodeSelected.menus[i].ssmenus[j].id.toString() === id.toString()) {
					return this.nodeSelected.menus[i];
				}
			}
		}
		return null;
	};

	this.removeSsMenu = function (indexMenu, indexSsMenu) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === this.nodeSelected.type) {
				this.tree[i].menus[indexMenu].ssmenus.splice(indexSsMenu,1);
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
		this.selectNode(this.nodeSelected.type);
	};

	this.removeCurrentSsMenu = function () {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			if (this.nodeSelected.menus[i] === this.menuSelected) {
				for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
					if (this.nodeSelected.menus[i].ssmenus[j] === this.ssMenuSelected) {
						this.nodeSelected.menus[i].ssmenus.splice(j, 1);
						for (var k = 0; k < this.tree.length; k++) {
							if (this.tree[k].type === this.nodeSelected.type) {
								this.tree[k].menus[i].ssmenus.splice(j, 1);
								$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
							}
						}
					}
				}
			}
		}
	};

	this.addSsMenu = function (indexMenu, index, item) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === this.nodeSelected.type) {
				this.tree[i].menus[indexMenu].ssmenus.splice(index, 0, item);
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.removeDossier = function (indexMenu, dossier) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === 'D') {
				for (var j = 0; j < this.tree[i].menus[indexMenu].ssmenus.length; j++) {
					if (this.tree[i].menus[indexMenu].ssmenus[j].id === dossier.noDossier) {
						this.tree[i].menus[indexMenu].ssmenus.splice(j, 1);
					}
				}
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.selectNode = function (type) {
		this.tree = $localStorage.get(this.LOCAL_STORAGE_KEY);
		if (this.tree === null) {
            this.tree = [];
        }
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === type) {
				this.nodeSelected = this.tree[i];
				return this.tree[i];
			}
		}
		return null;
	};

	this.getNode = function () {
		return this.selectNode(this.nodeSelected);
	};

	this.createNode = function (type, label, isRecherche, urlRecherche) {

		var newNode = {
			type: type,
			menus: []
		};

		if (isRecherche) {
			newNode.menus.push({label: 'Recherche',
				url: urlRecherche,
				ssmenus: []});
		}
		newNode.menus.push({label: label,
			url: '',
			ssmenus: []});

		this.tree.push(newNode);
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.getIdSsMenuSelected = function () {
		return this.idSsMenuSelected;
	};

	this.setIdSsMenuSelected = function (id) {
		this.menuSelected = this.searchMenu(id);
		this.ssMenuSelected = this.searchSsMenu(id);
		this.idSsMenuSelected = id;
	};

});
